import { ROOT_SLICE_LINES_STATE } from '../constants';

export const selectSliceState = (state = {}) =>
	state[ROOT_SLICE_LINES_STATE] || state;

export const selectItems = state => {
	const { items } = selectSliceState(state);
	return items;
};

export const selectServerItems = state => {
	const { serverItems } = selectSliceState(state);
	return serverItems;
};

export const selectIsLoadingIsLoaded = (state) => {
	const { isLoading, isLoaded } = selectSliceState(state);
	return { isLoading, isLoaded };
}

export const selectIsLoaded = state => {
	const { isLoaded } = selectIsLoadingIsLoaded(state);
	return isLoaded;
};

export const selectIsLoading = state => {
	const { isLoading } = selectIsLoadingIsLoaded(state);
	return isLoading;	
};

export const selectErrorMessage = (state) => {
	const { errorMessage } = selectSliceState(state);
	return errorMessage;	
};
